export class TimezoneModel {
    id: string;
    hasIanaId: boolean;
    standardName: string;
    daylightName: string;
    timezoneId: string;
    baseUtcOffset:string;
    displayName: string;
    supportsDaylightSavingTime: boolean;
    constructor(timezone: any) {
        this.timezoneId = timezone.id;
        this.displayName = timezone.displayName;
        this.standardName = timezone.standardName;
        this.daylightName = timezone.daylightName;
        this.baseUtcOffset = timezone.baseUtcOffset;
        this.supportsDaylightSavingTime = timezone.supportsDaylightSavingTime;
        this.hasIanaId = timezone.hasIanaId;
        this.id = timezone.id;
    }
}